import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../services/context";

const PermissionGuard = ({ children, requiredPermission }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const navigate = useNavigate();

  const [checked, setChecked] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const [module, permission] = requiredPermission.split(":");
    const hasPermission = permissions?.some(
      (perm) => perm.module === module && perm.type === permission
    );

    setIsAllowed(hasPermission);
    setChecked(true);

    if (!hasPermission) {
      navigate("/unauthorized", { replace: true });
    }
  }, [permissions, requiredPermission, navigate]);

  if (!checked) return null;

  return isAllowed ? children : null;
};

export default PermissionGuard;
